<template>
  <div class="!flex flex-col group">
    <div class="h-full relative !flex flex-col border border-grey-border">
      <div :class="{ 
          'grid place-items-center': !item.image,
          'w-full bg-{{theme}} min-h-[200px]': true }"
      >
        <img v-if="item.image" :src="item.image" class="w-full h-full object-cover" :alt="item.title">

        <img v-else src="/assets/images/logos/bury--white.svg" class="w-[100px] h-16" width="100" height="64" alt="">
      </div>

      <div v-if="filterCard" :class="`absolute top-0 -z-1 flex flex-col items-center justify-center w-full h-full px-3 pb-8 text-white font-crimson
        bg-${theme} opacity-0 lg:group-hover:opacity-100 lg:group-hover:z-10 transition-all duration-300`"
      >
        <p class="px-2 mt-2 -mb-2 text-sm">
          {{ item.entryType }}
        </p>

        <h5 class="my-2 text-[25px] leading-[30px] text-center lg:mt-3 lg:text-3xl">
          {{ item.title.length > 35 ? item.title.slice(0, 35) + '...' : item.title }}
        </h5>

        <p v-if="item.body" class="text-lg leading-[25px] text-center">
          {{ item.body.length > 75 ? item.body.slice(0, 75) + '...' : item.body }}
        </p>

        <a
          :href="item.url || item.uri"
          @click="sendEvent('click', item, 'Entry Clicked')"
          :class="`
            ${item.address || item.endDate ? 'lg:mb-12' : ''}
            mx-auto mt-4 bg-white button border text-${theme} hover:bg-${theme} hover:text-white hover:border-white hover-shadow
          `"
        >
          View
        </a>
      </div>

      <div class="relative flex flex-col h-full grow text-center font-crimson bg-white clip before:-top-[19px] before:left-0 before:absolute
        before:w-full before:h-5 before:bg-white lg:before:-top-[35px] lg:before:h-9"
      >
        <div class="flex flex-col grow justify-center">
          <p class="hidden px-2 -mb-2 text-sm text-grey lg:block">
            {{ item.entryType }}
          </p>

          <h5 :class="`
            ${item.address || item.endDate ? 'lg:mb-4' : 'lg:mb-10' }
            'mt-3 px-2 text-[25px] leading-[30px] lg:mt-3 lg:text-3xl text-${theme}`">
            {{ item.title.length > 35 ? item.title.slice(0, 35) + '...' : item.title }}
          </h5>

          <a v-if="filterCard" :href="item.url || item.uri" @click="sendEvent('click', item, 'Entry Clicked')" :class="`mx-auto lg:hidden text-${theme} button`">
            View {{ item.entryType }}
          </a>

          <div v-else>
            <p v-if="item.previewText" class="text-lg text-grey leading-[25px] px-2">
              {{ (item.previewText.length > 55 ? item.previewText.slice(0, 55) + '...' : item.previewText)|striptags }}
            </p>

            <a :href="item.url || item.uri" :class="`mb-6 mx-auto mt-3 text-white w-fit button hover-shadow hover:bg-purple-light 
              bg-${theme}`"
            >
              View More
            </a>
          </div>
        </div>

        <div v-if="item.address || item.startDate || item.nextDate || item.endDate" class="relative z-20 text-lg leading-5 text-left text-grey lg:block lg:mt-4">
          <p v-if="item.address" class="flex px-4 py-3 border-t border-grey-border bg-grey-lightest gap-x-6">
            <img src="/assets/images/icons/location-marker.svg" width="14" height="20" alt="">

            {{ item.address.length > 60 ? item.address.slice(0, 60) + '...' : item.address }}
          </p>

          <p v-if="item.startDate || item.nextDate || item.endDate" class="flex px-4 py-3 border-t border-grey-border bg-grey-lightest gap-x-6">
            <img data-src="/assets/images/icons/clock.svg" class="lazyload" width="14" height="20" alt="">

            <span v-if="item.nextDate && item.endDate && item.nextDate === item.endDate">
              {{ item.endDate|formatDate }}
            </span>

            <span v-else-if="(item.startDate || item.nextDate) && item.endDate">
              {{ (item.startDate ? item.startDate.date : item.nextDate)|formatDate }} - {{ (item.endDate.date || item.endDate)|formatDate }}
            </span>

            <span v-else-if="item.startDate || item.nextDate">
              Starts {{ (item.startDate ? item.startDate.date : item.nextDate)|formatDate }}
            </span>

            <span v-else>
              Ends {{ (item.endDate.date || item.endDate)|formatDate }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import Vue from 'vue';

  Vue.filter('formatDate', (value) => {
    if (!value) return '';

    let dt = moment(String(value));
    return dt.isValid() ? dt.format('D MMMM, YYYY hh:mma') : moment.unix(value).format('Do MMM');
  })

  Vue.filter('striptags', (value) => {
    return value ? value.replace(/<(?:.|\n)*?>/gm, '') : '';
  })

  export default {
    name: "MediumCard",
    props: {
      item: {
        type: Object,
        required: true
      },
      sendEvent: {
        type: Function,
      },
      theme: {
        type: String,
        default: 'purple'
      },
      filterCard: {
        type: Boolean,
        default: true,
      }
    },
    mounted() {
        let externalScript = document.createElement('script');
        externalScript.setAttribute('src', '/assets/js/moment.js');
        document.head.appendChild(externalScript);
    },
  };
</script>